import { render, staticRenderFns } from "./PokedexRow.vue?vue&type=template&id=e5579078&scoped=true&lang=pug&"
import script from "./PokedexRow.vue?vue&type=script&lang=js&"
export * from "./PokedexRow.vue?vue&type=script&lang=js&"
import style0 from "./PokedexRow.vue?vue&type=style&index=0&id=e5579078&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5579078",
  null
  
)

export default component.exports